import React from 'react';
import { Row, Col, FormControl } from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';

const SearchBar = ({ searchText, handleSearch, clearSearch }) => (
  <Row className="searchbar-view">
    <Col md={12}>
      <FormControl
        type="text"
        value={searchText}
        className="searchbar-input"
        placeholder="Search here"
        onChange={(e) => handleSearch(e)}
      />
      {searchText.length > 0 ? (
        <FontAwesome
          className="close-icon"
          name="times"
          onClick={(e) => clearSearch(e)}
        />
      ) : (
        <FontAwesome className="search-icon" name="search" />
      )}
    </Col>
  </Row>
);

export default SearchBar;



// WEBPACK FOOTER //
// src/components/SearchBar.jsx